import connectWithCoreImport from 'framework/hocs/connectWithCore';

export const connectWithCore = connectWithCoreImport;
export const connectDynamic = connectWithCoreImport;

export default {
  connectWithCore,
  connectDynamic,
};
